import { render, staticRenderFns } from "./SatisfactionQuestion.vue?vue&type=template&id=981b7574&scoped=true&"
import script from "./SatisfactionQuestion.vue?vue&type=script&lang=js&"
export * from "./SatisfactionQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionQuestion.vue?vue&type=style&index=0&id=981b7574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b7574",
  null
  
)

export default component.exports